import apiSauce from "./api-sauce";

export class ResumeAPI {

  async get_structured_data_from_cv(payload): Promise<any> {
    return await apiSauce.apisauce.post("gen/extract-text", JSON.stringify(payload))
  }

}
